"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RADII = void 0;
var RADII = {
  CORNER: 'corner',
  ROUND_CORNER_1X: 'roundCorner1x',
  ROUND_CORNER_2X: 'roundCorner2x',
  ROUND: 'round'
};
exports.RADII = RADII;